export const shuffelArray = (array: any[]) =>
  [...array].sort(() => Math.random() - 0.5);
